import { render, staticRenderFns } from "./ApproveShareclass.vue?vue&type=template&id=6ed35acb&"
import script from "./ApproveShareclass.vue?vue&type=script&lang=js&"
export * from "./ApproveShareclass.vue?vue&type=script&lang=js&"
import style0 from "./ApproveShareclass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports